<well-signup-card-layout
  [title]="'signup.contact' | translate"
  [icon]="true"
>
  <i [ngClass]="iconClass" rightIcon></i>
  @if(meta && firstContact) {
    <signup-first-contact-inputs [meta]="meta" [firstContact]="firstContact" (save)="onFirstContactSave($event)" body></signup-first-contact-inputs>
  }
</well-signup-card-layout>


